<template>
  <div :id="id" class="full-height">
  </div>
</template>

<script>
import echarts from 'echarts'
import resize from '@/components/echarts/mixins/resize'
export default {
  mixins: [resize],
  name: 'StackedColumn',
  components: {

  },
  props: {
    id: { type: String, default: new Date().getTime() + '' }
  },
  data () {
    return {
      chart: null,
      echartOptions: {

      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initChart()
  },
  watch: {

  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.setOption(this.echartOptions)
    },
    initOptions (val) {
      this.refreshOptions(this.echartOptions)
    },
    refreshOptions (val) {
      if (this.chart) {
        this.chart.setOption(val)
      }
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
}
</script>

<style scoped lang="stylus">
.full-height
  height 100%
</style>
